import React from 'react'
import './footer.styles.css'

export const Footer = () => (
  <div className='footer'>
    <a className='footer-link' 
      href='https://github.com/LawrenceCastillo/ada-theme-react-template' 
      target="_blank" 
      rel='noopener noreferrer'> 
        "Ada" theme designed and built by Lawrence Castillo 
    </a>
  </div>
)